import { ColorOptions } from '@shared/models';

export enum StatusOptions {
	NOT_VERIFIED = 'not-verified',
	ACTIVE = 'active',
	BLOCKED = 'blocked',
	PENDING_TWO_FA = 'pending-two-fa'
}

export type Status = `${StatusOptions}`;

export const statusNames: Record<Status, string> = {
	[StatusOptions.NOT_VERIFIED]: 'status.not-verified',
	[StatusOptions.ACTIVE]: 'status.active',
	[StatusOptions.BLOCKED]: 'status.blocked',
	[StatusOptions.PENDING_TWO_FA]: 'status.pending-two-fa'
};

export function statusIconColor(status: Status): ColorOptions {
	switch (status) {
		case StatusOptions.NOT_VERIFIED:
			return ColorOptions.WARNING;
		case StatusOptions.PENDING_TWO_FA:
			return ColorOptions.WARNING;
		case StatusOptions.ACTIVE:
			return ColorOptions.SUCCESS;
		case StatusOptions.BLOCKED:
			return ColorOptions.GRAY_30;
		default:
			return ColorOptions.GRAY_60;
	}
}
